export default __webpack_public_path__ + "static/media/icon-menu.c6107d03.svg";